<template>
  <div class="sn-page sn-assembly pay-pattern">
    <sn-popup :title="$sn.utils.getFunctionTitle('0', params.func)" :cancel="false" @sendBack="sendBack">
      <div class="sn-f-col-b-c pattern">
        <div class="sn-f-1 pattern-region">
          <template v-if="regInfo.length > 0">
            <div class="pattern-title">请选择支付方式</div>
            <div class="sn-f-s-c">
              <div class="sn-f-c-c sn-pointer reg-blank"
              :style="{'--background': item.background}"
              :class="{'interaction': selected.reg === item.reg}"
              :key="item.reg" v-for="item in regInfo" @click="selected.reg = item.reg;">
                <div class="iconfont" :class="item.icon"></div>
                <div>{{ item.title }}</div>
              </div>
            </div>
          </template>
        </div>
        <div class="sn-f-s-0 sn-f-e-c pattern-bottom">
          <div class="sn-f-c-c sn-pointer interaction" @click="sendBack(true);">确认</div>
        </div>
      </div>
    </sn-popup>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'pay-pattern',
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      channelInfo: [],
      regInfo: [],
      selected: {
        channel: '',
        reg: ''
      }
    };
  },
  created: function() {
    if (!this.$sn.validate.empty(this.params.reg)) {
      const compare = {
        '1': {
          'title': '支付宝',
          'icon': 'icon-alipay',
          'background': this.$sn.color.alipay
        },
        '2': {
          'title': '微信',
          'icon': 'icon-weixin2',
          'background': this.$sn.color.wechat
        }
      };
      this.params.reg.forEach(el => {
        if (!this.$sn.validate.empty(compare[el])) {
          this.regInfo.push({
            reg: el,
            ...compare[el]
          });
        }
      });
    }
  },
  methods: {
    sendBack(type) {
      if (type) {
        if (this.$sn.validate.empty(this.selected.channel) && this.$sn.validate.empty(this.selected.reg)) return false;
      }
      this.$emit('sendBack', type, this.selected);
    }
  }
};
</script>
<style lang="scss" scoped>
.pay-pattern {
  z-index: 999;

  .pattern {
    overflow: hidden;
    width: 500px;
    max-height: 400px;
    padding: 20px;

    &-region {
      overflow-x: hidden;
      overflow-y: auto;
      width: 100%;

      .pattern-title {
        @include fs(18);

        overflow: hidden;
        width: 100%;
        font-weight: bold;
        color: $text1;
        margin-bottom: 20px;
      }

      .reg-blank {
        width: 160px;
        height: 40px;
        color: $text1;
        border: 1px solid $border1;
        border-radius: 4px;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }

        &.interaction {
          background-color: var(--background);
          color: $white;
          border: none;

          .iconfont {
            color: $white;
          }
        }

        .iconfont {
          font-size: 18px;
          color: $text1;
          margin-right: 10px;
        }
      }
    }

    &-bottom {
      overflow: hidden;
      width: 100%;

      .interaction {
        @include fs(14);

        width: 120px;
        height: 40px;
        background-color: $main;
        color: $white;
        border-radius: 5px;
      }
    }
  }
}
</style>
